
import useForecast from "./useForecast.js";
import { Navbar2 } from "../../Components/Navbar2/Navbar2.js";
import SimpleFooter from "../../Components/SimpleFooter.jsx";
import LocationSearch from "../../Components/LocationSearch.jsx";
import WeatherSummary from "../../Components/WeatherSummary.jsx";
import WeatherGraphs from "../../Components/WeatherGraphs.jsx";
import WeatherTables from "../../Components/WeatherTables.jsx";
import LoadingSpinner from "../../Components/LoadingSpinner.jsx";
import LoginModal from "../Login/LoginModal.jsx";
import { useReduxStore } from "../../hooks/useReduxStore.js";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { toastConfiguration } from "../../Constant/Data.js";
import React, { useState } from "react";
import { bgGradient } from "../../Constant/Data.js";

const RADIO_OPTIONS = [
  { label: "Previous Hours", value: "prevHours" },
  { label: "Next Hours", value: "nextHours" },
  { label: "Previous Days", value: "prevDays" },
  { label: "Next Days", value: "nextDays" },
];

export default function Forecast() {
  const { getState } = useReduxStore();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  
  // Get authentication state
  const { token } = getState("AUTH");

  const {
    location,
    previewQuery,
    clearPreview,
    getGeolocation,
    getCurrentLocation,
    searchLocation,
    weatherData,
    hourlyData,
    dailyData,
    loading,
    error,
    selectedView,
    setSelectedView,
    isCurrentLocation,
    refetchData
  } = useForecast();

  // Get data based on selected view
  const getTableData = () => {
    switch (selectedView) {
      case "prevHours":
        return { hourly: hourlyData.slice(0, 24), daily: [] }; // Show all 24 hours for previous
      case "nextHours":
        return { hourly: hourlyData.slice(0, 24), daily: [] }; // Show all 24 hours for next
      case "prevDays":
        return { hourly: [], daily: dailyData };
      case "nextDays":
        return { hourly: [], daily: dailyData };
      default:
        return { hourly: hourlyData, daily: dailyData };
    }
  };
  const { hourly, daily } = getTableData();

  // Determine if showing hourly or daily
  const isHourly = selectedView === "prevHours" || selectedView === "nextHours";
  const isDaily = selectedView === "prevDays" || selectedView === "nextDays";

  // Handle button clicks with authentication check
  const handleButtonClick = (page) => {
    if (!token) {
      toast.error("Please login first to access this feature", toastConfiguration);
      setShowLoginModal(true);
      return;
    }
    
    // Navigate to the respective page
    switch (page) {
      case "forecast":
        // navigate("/Forecast");
        break;
      case "api":
        navigate("/Dashboard/ApiKeys");
        break;
      case "alerts":
        navigate("/Dashboard/Alerts");
        break;
      case "subscription":
        navigate("/Dashboard/Subscription");
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Navbar2 />
      <div className="center w-screen overflow-hidden">
        <div
          style={{ background: bgGradient }}
          className="px-10 min-h-screen w-screen pb-28 pt-28 lg:px-44 flex flex-col justify-center items-center"
        >
           <LocationSearch
            onSearch={searchLocation}
            onGeolocate={getGeolocation}
            onCurrentLocation={getCurrentLocation}
            loading={loading}
            error={error}
            isCurrentLocation={isCurrentLocation}
          />

                {weatherData && (
                  <div className="w-full max-w-7xl mb-6">
                    <div className="bg-[#20293F] bg-opacity-80 rounded-lg p-4 border border-borderGray">
                      <div className="flex items-center gap-3">
                        <svg className="w-5 h-5 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <div>
                          <h2 className="text-xl font-bold text-white">
                            {weatherData?.location?.name || location.name}
                          </h2>
                          <p className="text-sm text-gray-300">
                            {weatherData?.location?.state && `${weatherData.location.state}, `}
                            {weatherData?.location?.country && weatherData.location.country}
                          </p>
                        </div>
                        <div className="ml-auto flex items-center gap-2">
                          {previewQuery ? (
                            <>
                              <span className="text-xs text-purple-300 bg-purple-500/20 px-2 py-0.5 rounded-full">Preview only</span>
                              <button
                                type="button"
                                onClick={clearPreview}
                                className="text-xs text-gray-400 hover:text-white underline"
                              >
                                Back to active
                              </button>
                            </>
                          ) : (
                            <>
                              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
                              <span className="text-xs text-gray-400">
                                {isCurrentLocation ? 'Live' : 'Active'}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
         
          {loading && <LoadingSpinner />}
          {error && (
            <div className="bg-red-500/20 border border-red-500 text-red-200 px-4 py-3 rounded-lg mb-4">
              {error}
            </div>
          )}

          {!loading && weatherData && (
            <>
              {/* Simple Location Display */}
         
              
              {/* Radio Button Group */}
              <div className="flex gap-4 mb-2 w-full max-w-7xl bg-[#20293F] bg-opacity-80 p-6 rounded-xl shadow-md">
                {RADIO_OPTIONS.map((opt) => (
                  <label key={opt.value} className="flex items-center gap-2 text-white cursor-pointer">
                    <input
                      type="radio"
                      name="forecastView"
                      value={opt.value}
                      checked={selectedView === opt.value}
                      onChange={() => setSelectedView(opt.value)}
                      className="accent-secondary h-4 w-4"
                    />
                    <span>{opt.label}</span>
                  </label>
                ))}
                <button
                  onClick={refetchData}
                  disabled={loading}
                  className="ml-auto bg-secondary hover:bg-secondary/80 text-white px-4 py-2 rounded-md transition disabled:opacity-50"
                >
                  {loading ? 'Loading...' : 'Refresh'}
                </button>
              </div>
              {/* Show only one table/graph at a time */}
              {isHourly && (
                <>
                  <WeatherTables hourlyData={hourly} dailyData={[]} darkMode />
                  <WeatherGraphs hourlyData={hourly} dailyData={[]} darkMode />
                </>
              )}
              {isDaily && (
                <>
                  <WeatherTables hourlyData={[]} dailyData={daily} darkMode />
                  <WeatherGraphs hourlyData={[]} dailyData={daily} darkMode />
                </>
              )}
            </>
          )}
    {  !loading&&    <div className="flex justify-between  items-center space-x-4  py-6 w-full">
    {/* <button className="bg-[#212C43] border border-[#4A5567] text-white px-6 py-3 rounded-md font-medium hover:bg-[#3662E3] transition-colors duration-300">
      Quick Forecast Summary
    </button> */}
    <button 
      // onClick={() => handleButtonClick("forecast")}
      disabled
      className="bg-[#3662E3] border border-[#4A5567] text-white px-10 py-3 rounded-md font-medium hover:bg-[#3662E3] transition-colors duration-300"
    >
      View Forecast
    </button>
    <button 
      onClick={() => handleButtonClick("api")}
      className="bg-[#212C43] border border-[#4A5567] text-white px-10 py-3 rounded-md font-medium hover:bg-[#3662E3] transition-colors duration-300"
    >
      API Access
    </button>
    <button 
      onClick={() => handleButtonClick("alerts")}
      className="bg-[#212C43] border border-[#4A5567] text-white px-10 py-3 rounded-md font-medium hover:bg-[#3662E3] transition-colors duration-300"
    >
      Alerts
    </button>
    <button 
      onClick={() => handleButtonClick("subscription")}
      className="bg-[#212C43] border border-[#4A5567] text-white px-10 py-3 rounded-md font-medium hover:bg-[#3662E3] transition-colors duration-300"
    >
      Subscription
    </button>
  </div>}
        </div>
      </div>
      <SimpleFooter />
      <LoginModal 
        open={showLoginModal} 
        onClose={() => setShowLoginModal(false)} 
      />
    </>
  );
}
